import './contextLoading.css'

export const defaultProps = {
  title: 'Die Anwendung konnte nicht geladen werden',
  contextName: 'energy',
  action: 'javascript:window.location.reload()',
  actionText: 'Erneut versuchen',
  fallbackAction: "location.href='/__publicPath__/'",
  fallbackActionText: 'Zurück zur Startseite'
}

export const contextProps = {
  mfe_card: {
    title: 'Ihre Kartenverträge konnten nicht geladen werden',
    contextName: 'card'
  },
  mfe_energy: {
    title: 'Ihre Energieverträge konnten nicht geladen werden',
    contextName: 'energy'
  },
  mfe_emobility: {
    title: 'Ihre eMobilitäts-Verträge konnten nicht geladen werden',
    contextName: 'emobility'
  },
  mfe_profile: {
    title: 'Ihre Profilinformationen konnten nicht geladen werden',
    contextName: 'profile'
  }
}

export default (pageProps) => {
  const props = Object.assign({ ...defaultProps }, contextProps[pageProps.appName])

  return {
    template: `
      <div class="shell-error-page bg-grey-5 row justify-center items-center content-center">
        <div class="q-card shadow-4 q-pa-lg">
          <span class="row text-center" id="errorDescription">${props.title}</span>
          <div class="row justify-center items-center content-center error-icon-wrapper">
            <i class="q-icon text-grey-8 w-icon-cnxt_${props.contextName}"></i>
          </div>
          <div class="row justify-center items-center content-center q-gutter-lg">
            <a 
              class="q-btn q-btn-item non-selectable no-outline q-btn--outline q-btn--rectangle q-btn--actionable q-focusable q-hoverable q-btn--active" 
              type="button"
              onclick="${props.fallbackAction}"
            >
              <span class="q-focus-helper"></span>
              <span class="q-btn__content text-center col items-center q-anchor--skip justify-center row">
                <span class="block">${props.fallbackActionText}</span>
              </span>
            </a>
            <btn 
              class="q-btn q-btn-item non-selectable no-outline q-btn--standard q-btn--rectangle q-btn--actionable q-focusable q-hoverable q-btn--active" 
              type="button" 
              onclick="${props.action}"
            >
              <span class="q-focus-helper"></span>
              <span class="q-btn__content text-center col items-center q-anchor--skip justify-center row">
                <span class="block">${props.actionText}</span>
              </span>
            </btn>
          </div>
        </div>
      </div>
    `
  }
}
